import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'
import globals from '@/plugins/globals'
import store from '@/store'

export default {
  changeSort({ commit }, data) {
    commit(types.CHANGE_SORT, data)
  },
  resetCalibrateLists({ commit }, data) {
    commit(types.RESET_LIST, data)
  },
  setInsurance({ commit }, data) {
    commit(types.SET_INSURANCE_DATA, data)
  },
  async setLookups({ commit, dispatch, state }, data) {
    let profile = store.getters['auth/profile']
    let showInactive = false
    if (data.showInactive !== undefined && data.showInactive !== null) {
      showInactive = data.showInactive
    }
    let _keys = data.keys.filter(k => !state.lookups[k])
    if (data.refresh === undefined || data.refresh === null) {
      data.refresh = false
    }
    if (_keys.length || data.refresh) {
      if (data.firm === undefined || data.firm === null) {
        data.firm = profile.firm
      }
      const r = await startLoading(dispatch, 'setLookups', () =>
        http.post('lookup/ByKeys', {
          keys: data.keys,
          firm: data.firm,
          showInactive: showInactive
        })
      )
      commit(types.SET_LOOKUPS, [data.keys, r.data, showInactive])
    }
  },
  async getLookupsByGroup({ commit, dispatch, state }, { className, group }) {
    const r = await startLoading(dispatch, 'getLookupsByGroup', () => http.get(`lookup/ByGroup?className=${className}&group=${group}`))
    commit(types.SET_GROUPS, r.data)
  },
  async getOnboardLookups({ commit, dispatch, state }) {
    let showInactive = false
    let keys = ['StateProvince', 'Country', 'TimeZone', 'Language']
    const r = await startLoading(dispatch, 'getOnboardLookups', () => http.get('lookup/onboardLookups'))
    commit(types.SET_LOOKUPS, [keys, r.data, showInactive])
  },
  async upsertLookup({ commit, dispatch, state }, lookup) {
    const r = await startLoading(dispatch, 'upsertLookup', () => http.post('lookup/upsert', lookup))
    commit(types.UPSERT_LOOKUP, [lookup, r.data])
    return r
  },
  async deleteLookup({ commit, dispatch, state }, lookup) {
    let _lookup = Object.assign({}, lookup)
    _lookup.isActive = false
    const r = await startLoading(dispatch, 'deleteLookup', () => http.post('lookup/Delete', _lookup))
    if (r.data[0].Results === '') {
      commit(types.DELETE_LOOKUP, lookup)
    }
    return r
  },
  async upsertGroup({ commit, dispatch, state }, { id, name }) {
    let data = {
      id: id,
      text: name
    }
    const r = await startLoading(dispatch, 'deleteLookup', () => http.post('lookup/UpsertGroup', data))
    if (r.data === id) {
      commit(types.UPSERT_GROUP, data)
    }
    return r
  },
  async setCountries({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'setTimeZones', () => http.get('lookup/Countries'))
    let _data = globals.sortArray(r.data)
    commit(types.SET_COUNTRIES, _data)
  },
  async setTimeZones({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'setTimeZones', () => http.get('lookup/TimeZones'))
    let _data = globals.sortArray(r.data)
    commit(types.SET_TIMEZONES, _data)
  },
  async setStateProvinces({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'setStateProvinces', () => http.get(`lookup/StateProvince?id=${id}`))
    let _data = globals.sortArray(r.data)
    commit(types.SET_STATE_PROVINCES, _data)
  },
  async setLanguages({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'setLanguages', () => http.get('lookup/Languages'))
    let _data = globals.sortArray(r.data)
    commit(types.SET_LANGUAGES, _data)
  },
  async getCountryCode({ state }, id) {
    let code = null
    state.lookups['Country'].forEach(element => {
      if (parseInt(element.value) === parseInt(id)) {
        code = element.code
      }
    })
    return code
  },
  async getStateProvinceAbbr({ state }, id) {
    let abbr = null
    state.lookups['StateProvince'].forEach(element => {
      if (parseInt(element.value) === parseInt(id)) {
        abbr = element.name
      }
    })
    return abbr
  },
  async getCalibrateLists({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getCalibrateLists', () =>
      http.get(
        `lookup/calibrateLists?firm=${data.firm}&types=${data.types}&vehicleMake=${data.vehicleMake}&calibrateEventType=${
          data.calibrateEventType ? data.calibrateEventType : null
        }&insurance=${data.insurance ? data.insurance : null}`
      )
    )
    commit(types.SET_CALIBRATE_LISTS, r.data)
    return r.data
  },
  async getCalibrateReady({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getCalibrateReady', () =>
      http.get(`lookup/calibrateReady?firm=${data.firm}&inactive=${data.isinactive}&type=${data.type}&group=${data.group}`)
    )
    commit(types.SET_CALIBRATE_READY, r.data)
    return r.data
  },
  async saveCalibrateReady({ dispatch }, lookup) {
    const r = await startLoading(dispatch, 'saveCalibrateReady', () => http.post('lookup/saveCalibrateReady', lookup))
    return r.data
  },
  async getCalibratePreChecklist({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getCalibratePreChecklist', () =>
      http.get(`lookup/calibratePreChecklist?firm=${data.firm}&inactive=${data.isinactive}&type=${data.type}&group=${data.group}`)
    )
    commit(types.SET_CALIBRATE_PRECHECKLIST, r.data)
    return r.data
  },
  async saveCalibratePreCheck({ dispatch }, lookup) {
    const r = await startLoading(dispatch, 'saveCalibratePreCheck', () => http.post('lookup/saveCalibratePreChecklist', lookup))
    return r.data
  },
  async getCalibrateService({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getCalibrateService', () =>
      http.get(
        `lookup/calibrateService?firm=${data.firm}&inactive=${data.isinactive}&type=${data.type}&group=${data.group}&insurance=${data.insurance}`
      )
    )
    commit(types.SET_CALIBRATE_SERVICE, r.data)
    return r.data
  },
  async saveCalibrateService({ dispatch }, lookup) {
    const r = await startLoading(dispatch, 'saveCalibrateService', () => http.post('lookup/saveCalibrateService', lookup))
    return r.data
  },
  async getCalibrateActionType({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getCalibrateActionType', () =>
      http.get(`lookup/calibrateActionType?firm=${data.firm}&inactive=${data.isinactive}&type=${data.type}&group=${data.group}`)
    )
    commit(types.SET_CALIBRATE_ACTIONTYPE, r.data)
    return r.data
  },
  async saveCalibrateActionType({ dispatch }, lookup) {
    const r = await startLoading(dispatch, 'saveCalibrateActionType', () => http.post('lookup/saveCalibrateActionType', lookup))
    return r.data
  },
  async getCalibrateVerify({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getCalibrateVerify', () =>
      http.get(`lookup/calibrateVerify?firm=${data.firm}&inactive=${data.isinactive}&type=${data.type}`)
    )
    commit(types.SET_CALIBRATE_VERIFY, r.data)
    return r.data
  },
  async saveCalibrateVerify({ dispatch }, lookup) {
    const r = await startLoading(dispatch, 'saveCalibrateVerify', () => http.post('lookup/saveCalibrateVerify', lookup))
    return r.data
  },
  async saveSortSettings({ dispatch }, sortData) {
    const r = await startLoading(dispatch, 'saveSortSettings', () => http.post('lookup/saveSort', sortData))
    return r.data
  },
  async saveCalibrateEventType({ dispatch }, lookup) {
    const r = await startLoading(dispatch, 'saveCalibrateEventType', () => http.post('lookup/saveCalibrateEventType', lookup))
    return r.data
  },
  async saveCalibrateServiceGroup({ dispatch }, lookup) {
    const r = await startLoading(dispatch, 'saveCalibrateServiceGroup', () => http.post('lookup/saveCalibrateServiceGroup', lookup))
    return r.data
  },
  async deleteCalibrateServiceGroup({ dispatch }, calibrateServiceGroup) {
    const r = await startLoading(dispatch, 'deleteCalibrateServiceGroup', () =>
      http.delete(`lookup/deleteCalibrateServiceGroup?calibrateServiceGroup=${calibrateServiceGroup}`)
    )
    return r.data
  },
  async importCalibrateServices({ dispatch }, data) {
    const r = await startLoading(dispatch, 'importCalibrateServices', () =>
      http.post(`lookup/importCalibrateServices?isReplace=${data.isReplace}`, data.csv)
    )
    return r.data
  },
  async saveRateType({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveRateType', () => http.post('lookup/saveRateType', data))
    return r.data
  },
  async getCenterFirms({ dispatch, commit }, data) {
    const r = await startLoading(dispatch, 'getCenterFirms', () => http.get(`firm/getCenterFirms?firm=${data.firm}&contact=${data.contact}`))
    commit(types.SET_CENTER_FIRMS, r.data)
    return r.data
  },
  async revertCalibrateServices({ dispatch, commit }, data) {
    const r = await startLoading(dispatch, 'revertCalibrateServices', () =>
      http.get(`lookup/setCalibrateServices?firm=${data.firm}&inactive=${data.inactive}&inactivatedOn=${data.inactivatedOn}`)
    )
    return r.data
  },
  async getBrand({ dispatch, commit }, data) {
    let items = {
      firm: data.firm,
      category: 'Brand',
      refresh: true
    }
    const r = await startLoading(dispatch, 'getBrand', () =>
      http.get('firm/firmPreference', {
        params: items
      })
    )
    commit(types.SET_BRAND, r.data)
    return r.data
  },
  async getInsurance({ dispatch, commit }, firm) {
    if (firm === null || firm === undefined) {
      firm = 1
    }
    const r = await startLoading(dispatch, 'getInsurance', () => http.get(`lookup/insurance?firm=${firm}`))
    commit(types.SET_INSURANCE, r.data)
  },
  async saveInsurance({ dispatch, commit }, data) {
    const r = await startLoading(dispatch, 'saveInsurance', () => http.post('lookup/insurance', data))
    return r.data
  },
  async deleteInsurance({ dispatch, commit }, id) {
    const r = await startLoading(dispatch, 'deleteInsurance', () => http.get(`lookup/removeInsurance?id=${id}`))
    return r.data
  },
  async getInsuranceLookups({ dispatch, commit }, insurance) {
    const r = await startLoading(dispatch, 'getInsuranceLookups', () => http.get(`lookup/insuranceLookup?insurance=${insurance}`))
    commit(types.SET_INSURANCE_LOOKUP, r.data)
  },
  async saveInsuranceLookup({ dispatch, commit }, data) {
    const r = await startLoading(dispatch, 'saveInsuranceLookup', () => http.post('lookup/insuranceLookup', data))
    return r.data
  },
  async deleteInsuranceLookup({ dispatch, commit }, id) {
    const r = await startLoading(dispatch, 'deleteInsuranceLookup', () => http.get(`lookup/removeInsuranceLookup?id=${id}`))
    return r.data
  },
  async getPricingRules({ dispatch, commit }, firm) {
    const r = await startLoading(dispatch, 'pricingRules', () => http.get(`lookup/pricingRules?firm=${firm}`))
    commit(types.SET_PRICINGRULES, r.data)
    return r.data
  },
  async savePricingRule({ dispatch, commit }, data) {
    const r = await startLoading(dispatch, 'savePricingRule', () => http.post('lookup/pricingRule', data))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/actions.js